import Patrol from "../fragments/patrol";

export default `
mutation createPatrol(
  $displayName: String!,
  $patrolId: String!,
  $senderId: String!,
  $startCoordinates: CoordinatesInput!,
  $endCoordinates: CoordinatesInput!,
  $notes: String,
  $sendAlert: Boolean!,
  $propertyId: String!,
  $serviceProviderId: String!,
  $formattedAddress: String!,
  $startTime: Float!,
  $endTime: Float!
) {
  createPatrol(
    displayName: $displayName,
    patrolId: $patrolId,
    senderId: $senderId,
    startCoordinates: $startCoordinates,
    endCoordinates: $endCoordinates,
    notes: $notes,
    sendAlert: $sendAlert,
    propertyId: $propertyId,
    serviceProviderId: $serviceProviderId,
    formattedAddress: $formattedAddress,
    startTime: $startTime,
    endTime: $endTime
  ) ${Patrol}
}
`;
